var _style, _g, _path, _polygon, _path2, _polygon2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPgc1ALevelsGlucoseMetabolism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFC05D;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#315CA6;stroke-width:10.5;stroke-miterlimit:10;}\n\t.st2{fill:#315CA6;}\n\t.st3{fill:#E6393D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.3,90.4c7-18.7,25.1-32.1,46.2-32.1c25.5,0,46.4,19.3,49.1,44"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "157.1,115.5 168.3,93.3 138.6,98.9 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.4,123.2c-7,18.7-25.1,32.1-46.2,32.1c-25.4,0-46.3-19.1-49-43.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "54.5,98.1 43.3,120.2 73,114.7 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.5,80.8c-0.2,0.2-0.3,0.3-0.3,0.5c-4.9,7.5-9.7,15-14.6,22.6c-1.5,2.3-2.3,4.9-2.5,7.7 c-0.9,11.1,8.5,20.1,19.6,18.8c12.8-1.5,19.6-16.1,12.6-26.9c-1.7-2.6-3.4-5.3-5.1-7.9C112,90.7,108.8,85.8,105.5,80.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.5,80.8c3.2,5,6.4,9.9,9.6,14.8c1.7,2.6,3.4,5.3,5.1,7.9c7,10.8,0.2,25.3-12.6,26.9 c-11.1,1.3-20.5-7.7-19.6-18.8c0.2-2.8,1-5.4,2.5-7.7c4.8-7.5,9.7-15.1,14.6-22.6C105.3,81.1,105.4,81,105.5,80.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPgc1ALevelsGlucoseMetabolism);
export default __webpack_public_path__ + "static/media/PGC_1a_Levels_GlucoseMetabolism.eb6e78f76bf305751dbe63d697af8670.svg";
export { ForwardRef as ReactComponent };